module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/join-bg-03e49b759a7eb50eb2d4243a98c26ffb.jpg";